/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setAmount} from '../api'

export const useMutationSetAmount = createReactQueryMutationHook('setAmount', setAmount)
